"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quria = void 0;
const adapters_1 = require("./adapters");
const app_1 = require("./contents/app");
const communitycontent_1 = require("./contents/communitycontent");
const content_1 = require("./contents/content");
const destiny2_1 = require("./contents/destiny2");
const forum_1 = require("./contents/forum");
const groupv2_1 = require("./contents/groupv2");
const oauth_1 = require("./contents/oauth");
const tokens_1 = require("./contents/tokens");
const user_1 = require("./contents/user");
const trending_1 = require("./contents/trending");
const fireteam_1 = require("./contents/fireteam");
const fireteamfinder_1 = require("./contents/fireteamfinder");
const social_1 = require("./contents/social");
const core_1 = require("./contents/core");
class Quria {
    options;
    oauth;
    app;
    user;
    content;
    forum;
    groupv2;
    tokens;
    destiny2;
    communitycontent;
    trending;
    fireteam;
    fireteamfinder;
    social;
    core;
    constructor(config) {
        this.options = (0, adapters_1.generateOptions)(config);
        // Loads API endpoints paths
        this.oauth = new oauth_1.OAuth(this.options.urls.authorization, this.options.urls.token, this.options.headers, this.options.app.client_id, this.options.app.client_secret);
        this.app = new app_1.App(this.options.urls.api, this.options.headers);
        this.user = new user_1.User(this.options.urls.api, this.options.headers);
        this.content = new content_1.Content(this.options.urls.api, this.options.headers);
        this.forum = new forum_1.Forum(this.options.urls.api, this.options.headers);
        this.groupv2 = new groupv2_1.GroupV2(this.options.urls.api, this.options.headers);
        this.tokens = new tokens_1.Tokens(this.options.urls.api, this.options.headers);
        this.destiny2 = new destiny2_1.Destiny2(this.options.urls.api, this.options.headers);
        this.communitycontent = new communitycontent_1.CommunityContent(this.options.urls.api, this.options.headers);
        this.trending = new trending_1.Trending(this.options.urls.api, this.options.headers);
        this.fireteam = new fireteam_1.Fireteam(this.options.urls.api, this.options.headers);
        this.fireteamfinder = new fireteamfinder_1.FireteamFinder(this.options.urls.api, this.options.headers);
        this.social = new social_1.Social(this.options.urls.api, this.options.headers);
        this.core = new core_1.Core(this.options.urls.api, this.options.headers);
    }
}
exports.Quria = Quria;
